module.exports = __webpack_public_path__ + "media/assets/images/certificates/apave_9001_27001_small-ee9ba408d880fb650292dc282a802486.jpg";